import React from 'react';

import { contentCardMap } from '../ContentCards/Mappings';

const getCardLayout = (data, viewport, type) => {
  const cardLayoutMap = {
    0: (
      <div className="long-card image-hover" data-component-id="long_card_link">
        {React.createElement(contentCardMap[data.internal.type], {
          data,
          topic: true,
          type: viewport === 'mobile' ? 'standard' : 'long',
        })}
      </div>
    ),
    1: (
      <div
        className="standard-card one image-hover"
        data-component-id="standard_card_link"
      >
        {React.createElement(contentCardMap[data.internal.type], {
          data,
          topic: true,
          type: 'standard',
        })}
      </div>
    ),
    2: (
      <div
        className="standard-card two image-hover"
        data-component-id="standard_card_link"
      >
        {React.createElement(contentCardMap[data.internal.type], {
          data,
          topic: true,
          type: 'standard',
        })}
      </div>
    ),
  };

  return cardLayoutMap[type];
};

export const renderContentCards = (data, viewport) => {
  const buffer = []; // put podcast cards here if it falls under a 2x1 and content is not
  let bufferIndex = 0;

  const render = [];
  let type = 0;

  for (let i = 0; i < data.length; i += 1) {
    // nothing gets inserted and current index is pushed to buffer
    if (type === 0 && data[i].internal.type === 'ContentfulPodcast') {
      buffer.push(data[i]);
    } else {
      if (type !== 0 && bufferIndex < buffer.length) {
        render.push(getCardLayout(buffer[bufferIndex], viewport, type));
        bufferIndex += 1;
      } else {
        render.push(getCardLayout(data[i], viewport, type));
      }
      type = (type + 1) % 3;
    }
  }
  // Finish what's left in the buffer once the data is iterated over but stack only 1x1 1x1
  type %= 2;
  for (let i = bufferIndex; i < buffer.length; i += 1) {
    render.push(getCardLayout(buffer[bufferIndex], viewport, type + 1));
    bufferIndex += 1;
    type = (type + 1) % 2;
  }

  return render;
};
